import { formatDate } from "@marekl/adminer/format";
import { parseApiDate } from "@marekl/adminer/datetime";
import type { Season } from "../../../lib/queries/memberships";

/**
 * Where the active season's registration window stands, as one sentence.
 * Read-only here: the window is edited on the season, and it is what
 * decides whether the chooser offers „Člen ČNSMS" at all.
 */
export function seasonWindowSentence(season: Season | undefined): string {
  if (!season) return "Žádná sezóna není aktivní, registrační okno tedy neběží.";
  const from = season.registration_open_from;
  const to = season.registration_open_to;
  const day = (d: string) => formatDate(parseApiDate(d));
  switch (season.phase) {
    case "pre_registration":
      return from
        ? `Registrační okno sezóny ${season.code} se otevře ${day(from)}.`
        : `Registrační okno sezóny ${season.code} zatím není otevřené.`;
    case "registration_open":
      return to
        ? `Registrační okno sezóny ${season.code} je otevřené do ${day(to)}.`
        : `Registrační okno sezóny ${season.code} je otevřené.`;
    default:
      return `Registrační okno sezóny ${season.code} je uzavřené.`;
  }
}
